import React, { useEffect } from "react";
import Layout from "../../NewComponent/LayoutEmail/Layout";
import { Tag } from "antd";
import Button from "../../NewComponent/Button/Button";
import { getTicketRecords } from "../../API/api";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { Actions } from "../../Action";
import TicketTable from "./TicketTable";
import { Modal } from 'antd';
import PrimaryExpert from "./PrimaryExpert";
// import { fontWeight } from "html2canvas/dist/types/css/property-descriptors/font-weight";

export default function EmailHome() {
  const emailState = useSelector((state) => state.emailTicket);
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const dispatch = useDispatch();
  const { ET_UPDATE_TICKET_DATA, ET_UPDATE_TICKET_COUNT, ET_UPDATE_IS_LOADING } = bindActionCreators(Actions, dispatch);
  const containerStyles = {
    width: "90%",
    margin: "auto",
    marginTop: "1%",
    marginBottom: "7%",
    padding: "24px",
  };
const containerTableStyles = {
    width: "100%",
    margin: "auto",
    marginTop: "1%",
    marginBottom: "7%",
    border: '1px solid #EAECF0',
    boxShadow: '0px 4px 16px 0px #1018280F',
    borderRadius:'12px',
    minHeight:'450px',
    // padding: "24px",
  };
  const headigStyles = {
    fontSize: "20px",
    lineHeight: "32px",
    color: "#5C667B",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    fontWeight:'500'
  };
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const fetchTicketRecords = async () => {
    ET_UPDATE_IS_LOADING(true);
    getTicketRecords(emailState.pageNo, emailState.status,emailState.domain===null?'':emailState.domain, emailState.sort, emailState.search, emailState.assignedTo===null?'':emailState.assignedTo.split('&')[1], emailState.subject, emailState.threadId, emailState.emailBody, emailState.from).then(
      (res) => {
        ET_UPDATE_TICKET_DATA(res.data.data);
        ET_UPDATE_TICKET_COUNT(res.data.count);
        ET_UPDATE_IS_LOADING(false);
      }
    );
  };
  useEffect(() => {
    fetchTicketRecords();
  }, [emailState.pageNo,emailState.sort,emailState.refresh, emailState.search]);

  return (
    <Layout>
      <div style={containerStyles}>
        <div style={headigStyles}>
          <div>
            Email Threads&nbsp;
            {/* <span
              color="#00A3FF"
              style={{
                fontSize: "16px",
                lineHeight: "20px",
                // color: "#fff",
                padding: "5px",
              }}
            > */}
              <span>
        {" "}
        {emailState.count == 0 ? 0 : ((emailState.pageNo) * 20) + 1} to {" "}
        {((emailState.pageNo) * 20) + emailState.data.length} of {emailState.count}
      </span>
            {/* </span> */}
          </div>
          <div>
            <Button
            onClickFunc={showModal}
              text={
                <span style={{ fontSize: "14px", alignItems: "center", display: "flex" }}>
                  <i  className="fa fa-cogs" style={{fontSize:'20px', cursor:'pointer'}}></i>&nbsp;Settings
                </span>
              }
              type={"primary"}
            />
          </div>
        </div>
        <div style={containerTableStyles}>
          <TicketTable />
        </div>
      </div>
       <PrimaryExpert isModalOpen={isModalOpen} handleCancel={handleCancel} />
    </Layout>
  );
}
